import React, { Component, useState } from 'react';
import { Redirect, Link } from "react-router-dom";
import HeaderMenu from '../components/HeaderMenu'
import './index.scss';
import { useSelector } from 'react-redux'
function Task(props) {
  const { userId, userToken, userEmail, userName, isStatus, userRole, languageCode, isAdmin } = useSelector((state) => state.auth);
  const Components = props.component;

  const [collapsed, setStatesss] = useState(false)
  function toggleCollapsed() {
    setStatesss(!collapsed)
  };

  return (
    <div className="LiT-Body">
      <HeaderMenu collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
      <div className={`ss_page-body ${collapsed && 'bodyCollapsed'}`}>
    
        {(userToken) && (userRole === 'task') ? <Components /> : <Redirect to="/language"></Redirect>}
      </div>
      <div className="ss_page-footer">****</div>
    </div>
  );
}

export default Task;
